module.exports = __webpack_public_path__ + "static/img/1.c891dab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/1/1.png
// module id = 64jl
// module chunks = 0